
import { defineComponent } from "vue";
import NavHeader from "@/components/nav/NavHeader.vue";
import SearchBar from "../components/global/SearchBar.vue";
import * as Lang from "@/i18n/lang";
import Database from "@/model/Database";
import TrainingList from "@/components/trainings/TrainingList.vue";
import { getState } from "@/pinia/NavigationState";
import { getState as getAppState } from "@/pinia/AppState";
import User, { Role } from "@/model/User";
import { getTrainingState } from "@/pinia/trainings/TrainingState";
import { getTrainingManager } from "@/firebase/TrainingManager";
import { getTrainingsState } from "@/pinia/trainings/TrainingsState";
import { TrainingType } from "@/model/Trainings/TrainingType";
import LockedField from "@/components/global/LockedField.vue";
import ReadonlyField from "@/components/global/ReadonlyField.vue";
import Store from "@/model/Store";
import * as Snackbars from "@/utils/Snackbars";


export default defineComponent({
  components: {
    NavHeader,
    TrainingList,
    ReadonlyField
  },
  mounted() {
    this.state.selectedDatabase = null;
  },
  methods: {
    addTraining() {

      if (this.state.selectedDatabase == null && this.state.selectedStore == null && this.userRole != Role.Admin) {
        Snackbars.display("Please select a training source.");
        return;
      }
      getTrainingState().set(this.state.selectedDatabase!, null);
      getState().navigate("training");
    },

    async onStoreChange(store: Store) {
      if (store == null) {
        this.state.trainings = [];
        return;
      }

      this.state.trainings = await getTrainingManager().getTrainings(
        <User>getAppState().userData,
        null,
        store.ref,
      );

    },
    async onDatabaseChanged(database: Database) {

      if (database == null) {
        this.state.trainings = [];
        return;
      }
      this.state.trainings = await getTrainingManager().getTrainings(
        <User>getAppState().userData,
        database.ref
      );


      if (database != null && this.userRole == Role.Distributor) {
        this.state.trainings = this.state.trainings.filter(
          (training) => training.type == TrainingType.database
        );
      }
    },
  },
  async setup() {
    let state = getTrainingsState();

    let userRole = getAppState().userData.role;
    await state.setup();

    if (userRole != Role.Manager && userRole != Role.Customer) {
      state.trainings = await getTrainingManager().getTrainings(
        <User>getAppState().userData!
      );

    }

    return {
      state: state,
      userRole: userRole,
      Role: Role,
    };
  },
  data() {
    return { Lang: Lang };
  },
});
